import { Search } from '@domain-group/suit-theme'

import { EntityOptions } from '@redux/modules/module'

import { digObject } from '@domain-group/javascript-utils'

import CampaignImage from '@components/CampaignImage'

import searchFn from '@functions/search'

import type { CampaignModel } from '@models/types'

type MapCampaignResultsParams = {
  campaigns: CampaignModel[],
  secondaryTextProperty?: string,
}

const mapCampaignResults = (params: MapCampaignResultsParams) => {
  const {
    campaigns, secondaryTextProperty = 'id',
  } = params

  if (!campaigns.length){
    return {}
  }

  const results = {
    groups: [
      {
        key: 'campaign',
        title: 'CAMPAIGNS',
        items: campaigns
          .map((campaign) => {
            const secondaryText = digObject(campaign, secondaryTextProperty)
            const formattedSecondaryText = secondaryTextProperty === 'id' ? `#${secondaryText}` : secondaryText

            return ({
              ...campaign,
              iconLeft: (
                <CampaignImage
                  borderRadius={5}
                  campaign={campaign}
                  height={25}
                  width={40}
                />
              ),
              key: `Campaign-${campaign.id}`,
              secondaryText: formattedSecondaryText,
              text: campaign.title,
            })
          }),
      },
    ],
  }

  return results
}

interface CampaignSearchWithImageProps {
  callbacks: {
    onChange: (value: string) => void,
    selectItem: (item: CampaignModel) => void,
  },
  requestOptions?: EntityOptions,
  secondaryTextProperty: string,
}

const CampaignSearchWithImage = (props: CampaignSearchWithImageProps) => {
  const {
    callbacks: {
      selectItem,
    },
    requestOptions,
    secondaryTextProperty,
  } = props

  return (
    <Search
      boxProps={{ marginTop: '1px' }}
      callbacks={{
        // @ts-expect-error TS2322
        search: searchFn,
        // @ts-expect-error TS2322
        selectItem,
        // @ts-expect-error TS2741
        mapResults: campaigns => mapCampaignResults({
          // @ts-expect-error TS2322
          campaigns, secondaryTextProperty,
        }),
      }}
      debounceInterval={300}
      endpoint="campaigns.json"
      forwardProps={{
        closeOnSelect: true,
        setStringOnSelect: true,
        showOnFocus: true,
      }}
      requestOptions={{
        ...requestOptions,
        // @ts-expect-error TS2322
        include_campaign_image: true,
      }}
    />
  )
}

export default CampaignSearchWithImage
